/**
 * Parse create-proficiency-badge (axios) response shapes for the new badge id.
 */
export function extractCreatedProficiencyBadgeId(response) {
  const raw = response?.data;
  if (raw == null) return null;
  if (raw.id != null && raw.id !== "") return raw.id;
  if (raw.data?.id != null && raw.data.id !== "") return raw.data.id;
  if (raw.badge?.id != null && raw.badge.id !== "") return raw.badge.id;
  return null;
}

/**
 * Proficiency checkpoint APIs often return errors as a JSON array of strings, e.g.
 * ["Inspection not allowed. You cannot inspect an employee with a higher badge level..."]
 */
export function proficiencyCheckpointErrorMessage(error) {
  const d = error?.response?.data;
  if (Array.isArray(d) && d.length > 0) {
    const first = d[0];
    if (typeof first === "string" && first.trim() !== "") return first;
    if (first != null && first !== "") return String(first);
  }
  if (typeof d === "string" && d.trim() !== "") return d;
  if (d && typeof d === "object") {
    if (Array.isArray(d.non_field_errors) && d.non_field_errors[0]) {
      return String(d.non_field_errors[0]);
    }
    if (d.detail != null) {
      return Array.isArray(d.detail) ? String(d.detail[0] ?? "") : String(d.detail);
    }
  }
  return error?.message?.trim() ? error.message : null;
}
